import { InputFieldSet } from "PFComponents/text/input_field_set";
import { useNumberInput } from "PFCore/hooks/use_number_input";
import { AriaAttributes } from "react";

type NumberInputProps = {
  label?: string;
  controlledValue: number | undefined;
  onChange: (value: number | undefined) => void;
  max?: number;
  className?: string;
  inputClassName?: string;
  placeholder?: string;
  error?: string;
  disabled?: boolean;
  variant?: "default" | "table";
} & AriaAttributes;

export const NumberInput = ({
  label,
  controlledValue,
  onChange,
  max,
  className,
  inputClassName,
  placeholder,
  error,
  disabled,
  variant,
  ...ariaProps
}: NumberInputProps) => {
  const { value, handleChange } = useNumberInput({
    controlledValue,
    onChange,
    min: 0,
    max
  });

  return (
    <InputFieldSet
      label={label}
      min={0}
      max={max}
      value={value}
      onChange={handleChange}
      className={className}
      inputClassName={inputClassName}
      placeholder={placeholder}
      error={error}
      disabled={disabled}
      variant={variant}
      {...ariaProps}
    />
  );
};
